import React from 'react';
import { IconButton, Tooltip, Paper } from '@mui/material';
import {
  GridValueFormatterParams,
  GridRenderCellParams,
  GridValueGetterParams,
} from '@mui/x-data-grid-pro';
import { User as PersonIcon } from 'react-feather';
import { startCase } from 'lodash';
import moment from 'moment';
import { FullScreen } from '@pv/common/components';
import { moneyPrint } from '@pv/common/utils';
import { ADMIN_PAYMENTS_QUERY } from './graphql';
import { AdminReport } from '../reports';

export const PaymentsTable = () => {
  const allColumns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: true,
    },
    {
      field: 'venueName',
      headerName: 'Venue',
      flex: 1,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.venue?.name,
    },
    {
      field: 'eventName',
      headerName: 'Event',
      flex: 1,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.event?.name,
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      sortable: true,
    },
    {
      field: 'kind',
      headerName: 'Kind',
      flex: 1,
      sortable: true,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.kind ? startCase(params.row.kind) : '',
    },
    {
      field: 'mechanism',
      headerName: 'Mechanism',
      flex: 1,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.paymentMethod?.mechanism
          ? startCase(params.row.paymentMethod.mechanism)
          : '',
    },
    {
      field: 'brand',
      headerName: 'Brand',
      flex: 1,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.paymentMethod?.brand
          ? startCase(params.row.paymentMethod.brand)
          : '',
    },
    {
      field: 'paymentProvider',
      headerName: 'Payment Provider',
      flex: 1,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.paymentProvider ? startCase(params.row.paymentProvider) : '',
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      sortable: true,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.amount ? params.row.amount / 100.0 : 0,
      valueFormatter: (params: GridValueFormatterParams) =>
        moneyPrint(params.value || 0),
    },
    {
      field: 'state',
      headerName: 'State',
      flex: 1,
      sortable: true,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.state ? startCase(params.row.state) : '',
    },
    {
      field: 'scheduledAt',
      headerName: 'Scheduled At',
      flex: 1,
      sortable: false,
      valueFormatter: (params: GridValueFormatterParams) =>
        params.value ? moment(params.value).format('MM/DD/YYYY') : '-',
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      flex: 1,
      sortable: true,
      valueFormatter: (params: GridValueFormatterParams) =>
        params.value ? moment(params.value).format('MM/DD/YYYY') : '-',
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <Tooltip title="Login as User">
          <IconButton
            size="small"
            href={params.row.venue?.users?.[0]?.magicLoginLink}
            color="primary"
            onClick={(event: React.MouseEvent) => {
              event.stopPropagation();
            }}
          >
            <PersonIcon size={16} />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <FullScreen paddingBottom={24}>
        {({ height }) => (
          <Paper sx={{ height, width: '100%' }}>
            <AdminReport
              reportName="adminPayments"
              columns={allColumns}
              title="Payments"
              toolbar={true}
              query={ADMIN_PAYMENTS_QUERY}
            />
          </Paper>
        )}
      </FullScreen>
    </>
  );
};

export default PaymentsTable;
